import React, { useRef, useState } from "react";
import { Wizard, WizardPage, IWizardCommonProps } from "cayo.ui.wizards";
import { useIntl } from "react-intl";
import { communicationChannelsWizardMessages } from "../shared/messages";
import { TextField } from "cayo.ui";
import { smtpWizardMessages } from "./messages";
import { configureSmtpConnector } from "../shared/api";
import styled from "styled-components";

type WizardProps = IWizardCommonProps & {
  objects: { [key: string]: any }[];
};

export const SmtpCredentials = (props: WizardProps) => {
  const intl = useIntl();
  const wizardRef = useRef<{ resetError: () => void }>(null);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const [accountName, setAccountName] = useState<string>("");
  const [accountPassword, setAccountPassword] = useState<string>("");
  const objectId: string = props?.objects[0]?.id;
  const dataRef = useRef({
    accountName,
    accountPassword,
  });

  dataRef.current = {
    accountName,
    accountPassword,
  };

  return (
    <Wizard
      title={intl.formatMessage(smtpWizardMessages.changeCredTitle)}
      isFinished={isFinished}
      activePage={0}
      ref={wizardRef}
      showStepError
      closeConfirmationMessage={" "}
      {...props}
    >
      <WizardPage
        onNext={() => {
          return configureSmtpConnector(objectId, dataRef.current, () => setIsFinished(true));
        }}
        title={intl.formatMessage(smtpWizardMessages.enterCredentials)}
        stepName={intl.formatMessage(smtpWizardMessages.credentials)}
        subTitle={intl.formatMessage(smtpWizardMessages.credentialsSubTitle)}
        isInputValid={!!accountName && !!accountPassword}
      >
        <div>
          <TextField
            label={intl.formatMessage(smtpWizardMessages.userAccount)}
            value={accountName}
            required
            setValue={(value) => setAccountName(value as string)}
          />

          <TextField
            label={intl.formatMessage(smtpWizardMessages.passwordField)}
            value={accountPassword}
            type="password"
            isConfidential
            required
            setValue={(value) => setAccountPassword(value as string)}
          />
        </div>
      </WizardPage>

      <WizardPage
        onNext={() => Promise.resolve()}
        title={intl.formatMessage(communicationChannelsWizardMessages.summary)}
        stepName={intl.formatMessage(communicationChannelsWizardMessages.summary)}
        subTitle=""
      >
        <div>
          {isFinished && (
            <>
              <Text>
                <b>{intl.formatMessage(smtpWizardMessages.userName)}:</b> {accountName}
              </Text>
            </>
          )}
        </div>
      </WizardPage>
    </Wizard>
  );
};

const Text = styled.p`
  margin: 0;
`;
